/********************************************************************************
 * Copyright (c) 2021 Cedalo AG
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const date = (val) => val && val instanceof Date;
const nullOrUndefined = (val) => val == null;
const number = (val) => val != null && typeof val === 'number' && isFinite(val);
const object = (val) => val != null && typeof val === 'object';
const string = (val) => val != null && (typeof val === 'string' || val instanceof String);
const promise = (val) => val != null && val.toString() === '[object Promise]';
// if (obj) {
// 	const hasThen = typeof obj.then === 'function';
// 	const hasCatch = typeof obj.catch === 'function';
// 	return hasThen && hasCatch;
// }
// return false;


const isType = {
	date,
	nullOrUndefined,
	number,
	object,
	promise,
	string
};

module.exports = isType;
